import { scApi } from './shared';

/** Hand-authored YouTube endpoint copy and examples. */
export const YOUTUBE = scApi({
  id: 'youtube',
  name: 'YouTube',
  category: 'Video',
  color: 'var(--c-amber)',
  blurb:
    'Channels, videos and transcripts from YouTube as clean JSON: resolve by handle, channel id, URL or video id. Pay per request in real dollars, no quota juggling.',
  endpoints: {
    channel: {
      description: 'Channel overview by handle or channelId: title, description, subscriber and video counts, banner.',
      input: { handle: '@mkbhd' },
      sample: {
        channelId: 'UCBJycsmduvYEL83R_U4JriQ',
        handle: '@mkbhd',
        title: 'Marques Brownlee',
        description: 'Quality Tech Videos.',
        subscribers: 19_600_000,
        videos: 1_680,
        views: 4_120_000_000,
      },
    },
    video: {
      description: 'Full video or Short metadata by URL or id: title, description, channel, view/like counts and publish date.',
      input: { url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ' },
      sample: {
        id: 'dQw4w9WgXcQ',
        title: 'Official Video',
        channel: 'Rick Astley',
        durationMs: 213_000,
        views: 1_540_000_000,
        likes: 17_200_000,
        createdUtc: 1_256_453_853,
        description: 'The official video.',
      },
    },
    video_transcript: {
      description: 'Caption transcript for a video or Short by URL or id, with start/end timestamps per segment.',
      input: { url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ' },
      sample: {
        language: 'en',
        segments: [
          { start: 18.2, end: 21.0, text: 'Never gonna give you up' },
          { start: 21.0, end: 24.4, text: 'Never gonna let you down' },
        ],
      },
    },
    search: {
      description: 'Search YouTube and get matching videos: title, channel, view count, length and publish time.',
      input: { query: 'apollo 11 landing' },
      sample: {
        videos: [
          {
            id: 'BzSzwqb-OEE',
            url: 'https://www.youtube.com/watch?v=BzSzwqb-OEE',
            title: 'Apollo 11 Moon Landing: Restored Footage',
            channel: 'NASA',
            views: 14_860_541,
            lengthText: '4:14',
            publishedTime: '2 years ago',
          },
        ],
      },
    },
    channel_videos: {
      description: 'List a channel’s uploads by handle or channelId with cursor pagination: title, views, length and publish time.',
      input: { handle: '@mkbhd' },
      sample: {
        nextCursor: '4qmFsgLlFhIYV',
        videos: [
          {
            id: '5EWaxmWgQMI',
            url: 'https://www.youtube.com/watch?v=5EWaxmWgQMI',
            title: 'The cheapest flagship phone, reviewed',
            views: 4_120_000,
            lengthText: '12:48',
            publishedTime: '2 weeks ago',
          },
        ],
      },
    },
    video_comments: {
      description: 'List the comments on a video or Short by URL with cursor pagination: text, author, like and reply counts.',
      input: { url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ' },
      sample: {
        nextCursor: 'Eg0SCzVFV2F4bVd',
        comments: [
          {
            id: 'UgwVfRopfS2F-WB3aF14AaABAg',
            text: 'This is a masterpiece and no one can convince me otherwise.',
            author: '@SimonT80',
            likes: 110,
            replies: 5,
            publishedTime: '9 days ago',
          },
        ],
      },
    },
  },
});
